import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ShipFromContactModal } from 'ui-components/components/shipfrom-contact-modal';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { PickupContactPropType } from '../../../prop-types/pickup-contact';
import { editShipFromContact, extractErrorCollectionToMessageList } from '../../../carrier-pickup/carrier-pickup-api';

export const EditShipFromContactModal = ({ onEdit, onCancel, shipFromId, showDefaultLocationNotes = false, contact, onClose }) => {
  const [isSaving, setIsSaving] = useAsyncSafeState(false);
  const [errorCollection, setErrorCollection] = useAsyncSafeState([]);

  const onSubmit = useCallback(
    (newContact) => {
      setIsSaving(true);

      editShipFromContact(shipFromId, contact.shipFromContactId, newContact)
        .then(({ data }) => onEdit(contact.shipFromContactId, data))
        .catch(({ response }) => setErrorCollection(extractErrorCollectionToMessageList(response, [])))
        .finally(() => setIsSaving(false));
    },
    [setIsSaving, shipFromId, contact.shipFromContactId, onEdit, setErrorCollection],
  );

  const closeModal = useCallback(() => {
    if (!isSaving) {
      onCancel();
    }
  }, [isSaving, onCancel]);

  return (
    <ShipFromContactModal
      contact={contact}
      errorCollection={errorCollection}
      isSaving={isSaving}
      onCancel={closeModal}
      onClose={onClose}
      onSubmit={onSubmit}
      showDefaultLocationNotes={showDefaultLocationNotes}
    />
  );
};

EditShipFromContactModal.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  shipFromId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showDefaultLocationNotes: PropTypes.bool,
  contact: PickupContactPropType.isRequired,
};
